module.exports = __webpack_public_path__ + "img/project-5.292f652c.png";